import React from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import BelowFooter from "../BelowFooter/BelowFooter";

const Footer = ({ isAlbanian }) => {
  const navigate = useNavigate();

  return (
    <div id="page-container">
      <div className="footer-first-content-wrap"></div>
      <footer className="footer-first">
        <div className="footer-first-first-row">
          <div className="footer-first-logo-space">
            <img
              src="/vilallogonav.png"
              alt="logo-footer"
              className="footer-first-logo"
              onClick={() => navigate("/")}
              data-aos="fade-up"
              data-aos-duration="1000"
            />
          </div>
          <div className="footer-first-buttons">
            <div className="footer-first-row-buttons">
              <a
                href={`/`}
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "inline-flex",
                }}
              >
                <button data-aos="fade-up" data-aos-duration="800">
                  {isAlbanian ? "Kompania jonë" : "Our company"}
                </button>
              </a>

              <a
                href={`/ourcompany`}
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "inline-flex",
                }}
              >
                <button data-aos="fade-up" data-aos-duration="1000">
                  {isAlbanian ? "Projektet tona" : "Our projects"}
                </button>
              </a>
              <a
                href={`/salescatalog`}
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "inline-flex",
                }}
              >
                <button data-aos="fade-up" data-aos-duration="1000">
                  {isAlbanian ? "Katalogu i shitjeve" : "Sales catalog"}
                </button>
              </a>
            </div>
            <div className="footer-second-row-buttons">
              <a
                href={`/news`}
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "inline-flex",
                }}
              >
                <button
                  onClick={() => navigate("/news")}
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  {isAlbanian ? "Lajme" : "News & insight"}
                </button>
              </a>
              <a
                href={`/staff`}
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "inline-flex",
                }}
              >
                <button
                  onClick={() => navigate("/staff")}
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  {isAlbanian ? "Karriera" : "Career"}
                </button>
              </a>
              <button data-aos="fade-up" data-aos-duration="1000">
                {isAlbanian ? "Kontakt" : "Contact"}
              </button>
            </div>
          </div>
        </div>
        <div className="footer-first-third-part">
          <a
            href="https://www.facebook.com/share/19coQCi7jY/?mibextid=LQQJ4d"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/fb.svg"
              alt="Facebook"
              className="footer-first-social-icon"
              data-aos="fade-up"
              data-aos-duration="1000"
            />
          </a>
          <a
            href="https://www.instagram.com/vilalgroup?igsh=cWR2Nm1qdWlicnly"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/insta.svg"
              alt="Instagram"
              className="footer-first-social-icon"
              data-aos="fade-up"
              data-aos-duration="1000"
            />
          </a>

          <a
            href="https://www.linkedin.com/company/vila-l-sh-p-k/about/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/linkedin.svg"
              alt="Instagram"
              className="footer-first-social-icon"
              data-aos="fade-up"
              data-aos-duration="1000"
            />
          </a>
        </div>
      </footer>
      <BelowFooter isAlbanian={isAlbanian} />
    </div>
  );
};

export default Footer;
